/**
 * "FORAGER" wordmark rendered as an SVG so it never flashes a fallback font.
 * Paths are extracted from Jost SemiBold (600).
 * The viewBox pads ~1px (32 font units) beyond the glyph bounds to prevent anti-alias clipping.
 * Height matches CSS `font-size: 32px` (2rem) scaled to the viewBox height (824/1000).
 */
export function ForagerWordmark() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -51 5058 824"
      // Colors/Primary - Subtle/700 from the Brand & Style Guide
      fill="#2C7898"
      role="img"
      aria-label="Forager"
      height={`${2 * (824 / 1000)}rem`}
    >
      <g transform="scale(1, -1) translate(0, -722)">
        <path
          transform="translate(0, 0)"
          d="M168 575H481V700H168ZM168 299H471V418H168ZM76 700V0H214V700Z"
        />
        <path
          transform="translate(598, 0)"
          d="M187 350Q187 417 215.0 469.0Q243 521 292.0 551.0Q341 581 406 581Q472 581 521.0 551.0Q570 521 597.0 469.0Q624 417 624 350Q624 283 596.5 231.0Q569 179 520.0 149.0Q471 119 406 119Q341 119 292.0 149.0Q243 179 215.0 231.0Q187 283 187 350ZM36 350Q36 271 63.0 203.5Q90 136 140.0 86.0Q190 36 257.5 8.5Q325 -19 406 -19Q487 -19 554.5 8.5Q622 36 671.5 86.0Q721 136 748.5 203.5Q776 271 776 350Q776 430 748.5 496.5Q721 563 670.5 612.0Q620 661 553.0 687.5Q486 714 406 714Q327 714 259.5 687.5Q192 661 142.0 612.0Q92 563 64.0 496.5Q36 430 36 350Z"
        />
        <path
          transform="translate(1471, 0)"
          d="M235 326 445 0H614L386 326ZM76 700V0H219V700ZM163 578H302Q340 578 367.5 565.5Q395 553 410.0 529.5Q425 506 425 473Q425 440 410.0 416.5Q395 393 367.5 380.5Q340 368 302 368H163V254H311Q394 254 452.0 282.0Q510 310 541.0 360.5Q572 411 572 477Q572 544 541.0 594.0Q510 644 452.0 672.0Q394 700 311 700H163Z"
        />
        <path
          transform="translate(2153, 0)"
          d="M173 159H543L526 272H190ZM356 473 461 230 459 194 549 0H711L356 741L1 0H162L254 200L251 232Z"
        />
        <path
          transform="translate(2926, 0)"
          d="M416 260H617Q608 228 591.0 201.0Q574 174 549.5 153.0Q525 132 491.0 120.5Q457 109 414 109Q349 109 297.5 139.0Q246 169 216.0 223.5Q186 278 186 350Q186 423 216.5 476.0Q247 529 299.0 557.5Q351 586 414 586Q481 586 527.5 557.5Q574 529 600 483L722 554Q690 603 645.5 638.5Q601 674 543.5 694.0Q486 714 414 714Q333 714 264.0 688.0Q195 662 144.0 614.0Q93 566 64.5 498.5Q36 431 36 350Q36 269 63.5 201.0Q91 133 141.5 84.0Q192 35 260.5 8.0Q329 -19 410 -19Q496 -19 563.0 12.0Q630 43 675.5 97.5Q721 152 742.5 223.0Q764 294 761 374H416Z"
        />
        <path
          transform="translate(3790, 0)"
          d="M168 0H521V121H168ZM168 579H521V700H168ZM168 312H501V431H168ZM76 700V0H214V700Z"
        />
        <path
          transform="translate(4438, 0)"
          d="M235 326 445 0H614L386 326ZM76 700V0H219V700ZM163 578H302Q340 578 367.5 565.5Q395 553 410.0 529.5Q425 506 425 473Q425 440 410.0 416.5Q395 393 367.5 380.5Q340 368 302 368H163V254H311Q394 254 452.0 282.0Q510 310 541.0 360.5Q572 411 572 477Q572 544 541.0 594.0Q510 644 452.0 672.0Q394 700 311 700H163Z"
        />
      </g>
    </svg>
  )
}
